import { render, staticRenderFns } from "./BoardingTaskFilter.vue?vue&type=template&id=1b77340e&"
import script from "./BoardingTaskFilter.vue?vue&type=script&lang=js&"
export * from "./BoardingTaskFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports